import PropTypes from 'prop-types';
import PhoneNumberInput from './PhoneNumberInput';
import { useField } from 'formik';

export default function PhoneNumberInputField({ label, name, ...props }) {
  const [field, meta] = useField(name);

  const handleChange = (phoneNumber) => {
    // react-phone-input-2 onChange receives the phone number directly
    // but Formik's field.onChange expects an event object
    field.onChange({
      target: {
        name: field.name,
        value: phoneNumber,
      },
    });
  };

  return (
    <PhoneNumberInput
      isValid={!meta.touched || (meta.touched && !meta.error)}
      error={meta.error}
      label={label}
      {...props}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
      name={field.name}
    />
  );
}

PhoneNumberInputField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
};
